interface PullToRefreshIconProps {
    progress: number; // 0-1
    isReady: boolean; // 是否下拉到位
    isRefreshing?: boolean; // 是否正在刷新
}

export function PullToRefreshIcon( { progress, isReady, isRefreshing = false }: PullToRefreshIconProps ) {
    // 箭头路径的圆半径（匹配箭头路径，从中心点 (42, 42) 到箭头起点 (35.6456, 34.2785) 的距离 ≈ 10）
    const arrowCircleRadius = 10;
    const circumference = 2 * Math.PI * arrowCircleRadius; // ≈ 62.83

    // 箭头路径大约占圆周的 65%，作为最大进度条长度
    const maxProgressLength = circumference * 0.65; // ≈ 40.84

    // 进度条长度（不超过箭头长度，但达到最大长度后保持固定）
    const dashLength = Math.min( circumference * progress, maxProgressLength );
    const gapLength = circumference - dashLength;

    // 起点旋转角度（始终基于原始 progress，形成转圈效果：从顶部开始，随进度顺时针旋转）
    // 即使进度条长度达到最大值，起点角度仍然继续旋转
    const startAngle = -90 + ( progress * 360 );

    // 是否显示完整 SVG（到位或正在刷新）
    const showFullIcon = isReady || isRefreshing;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="84px"
            height="84px"
            viewBox="0 0 84 84"
            fill="none"
            className={isRefreshing ? "animate-spin" : ""}
            style={{ transformOrigin: "center" }}
        >
            <g filter="url(#filter0_d_11163_38443)">
                {/* 背景圆 */}
                <circle cx="42" cy="42" r="22" fill="var(--ui-market-no-subtle)" />

                {/* 未到位时：显示转圈进度条（动态起点转圈效果） */}
                {!showFullIcon && progress > 0 && (
                    <circle
                        cx="42"
                        cy="42"
                        r={arrowCircleRadius}
                        fill="none"
                        stroke="var(--ui-action-primary)"
                        strokeWidth="3"
                        strokeDasharray={`${dashLength} ${gapLength}`}
                        strokeDashoffset="0"
                        strokeLinecap="round"
                        transform={`rotate(${startAngle} 42 42)`}
                    />
                )}

                {/* 到位或刷新时：显示完整箭头 */}
                {showFullIcon && (
                    <g transform={isRefreshing ? undefined : `rotate(${startAngle} 42 42)`}>
                        <path
                            d="M35.6456 34.2785C31.3811 37.7878 30.7688 44.0898 34.2781 48.3543C37.7874 52.6189 44.0894 53.2312 48.354 49.7219C52.6186 46.2125 53.2308 39.9106 49.7215 35.646"
                            stroke="var(--ui-action-primary)"
                            strokeWidth="3"
                            fill="none"
                        />
                        <path
                            d="M40.3388 30.603L38.3956 37.6988L32.9697 31.0792L40.3388 30.603Z"
                            fill="var(--ui-action-primary)"
                        />
                    </g>
                )}
            </g>
            <defs>
                <filter
                    id="filter0_d_11163_38443"
                    x="0"
                    y="0"
                    width="84"
                    height="84"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="10" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.21 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11163_38443" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11163_38443" result="shape" />
                </filter>
            </defs>
        </svg>
    );
}
